import { render, staticRenderFns } from "./CustomizeCover.vue?vue&type=template&id=7dfa3f41&scoped=true&"
import script from "./CustomizeCover.vue?vue&type=script&lang=js&"
export * from "./CustomizeCover.vue?vue&type=script&lang=js&"
import style0 from "./CustomizeCover.vue?vue&type=style&index=0&id=7dfa3f41&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dfa3f41",
  null
  
)

export default component.exports